import React, { useContext, useEffect, useState } from "react";
import {
  Apex,
  Breeze,
  Classic,
  Creative,
  Edgy,
  Executive,
  Global,
  Magic,
  Professional,
  Rockstar,
} from "../../components/Designs";
import { ResumeContext } from "../../contexts/resumeContext";
import { Button } from "../../components";
import styles from "./resume.module.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Check, CheckAnimated, ChevronDown, ChevronLeft, CloudDoneAnimated, CloudUploadAnimated, CrossSvg, Download, Loader, MagicWand } from "../../components/Icons/Icons";
import {PreviewBar} from '../'
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
// import * as jsPDF from '../../assets/scripts/pdfjs.min.js';

function Resume(props) {
  const params = useParams();
  const navigate = useNavigate();

  const { resumeInfo, activeFontSize, activeDesign, activeColor, infoUpdating } =
    useContext(ResumeContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showPrevieBar, togglePreviewBar] = useState(false);

  const activeSection = searchParams.get("section");

  useEffect(() => {
    if (activeSection === "preview") {
      document.querySelector(`.${styles.previewWrapper}`)?.scrollTo(0, 0);
    }
  }, [activeSection]);

  const populateResumeDesign = (resumeInfo) => {
    switch (activeDesign) {
      case "magic":
        return <Magic info={resumeInfo} />;
      case "rockstar":
        return <Rockstar info={resumeInfo} />;
      case "breeze":
        return <Breeze info={resumeInfo} />;
      case "apex":
        return <Apex info={resumeInfo} />;
      case "edgy":
        return <Edgy info={resumeInfo} />;
      case "executive":
        return <Executive info={resumeInfo} />;
      case "creative":
        return <Creative info={resumeInfo} />;
      case "global":
        return <Global info={resumeInfo} />;
      case "classic":
        return <Classic info={resumeInfo} />;
      case "professional":
        return <Professional info={resumeInfo} />;
      default:
        return <Rockstar info={resumeInfo} />;
    }
  };

  const updateDocData = async () => {
    await setDoc(
      doc(db, "documents", params?.docId),
      { color: activeColor, fontSize: activeFontSize, design: activeDesign },
      { merge: true }
    );
  };

  const handleBack = () => {
    updateDocData();
    navigate(-1);
  };

  return (
    <>
       <button className={styles.backBtn} onClick={handleBack}>
        <ChevronLeft /> Back to Editor
      </button>
      <div className={styles.previewWrapper}>
        <div
          className={styles.preview}
          style={
            activeSection == "preview"
              ? {
                  fontSize: activeFontSize,
                  width: "21cm",
                  margin: "4em auto 0",
                  transform: "scale(0.95)",
                }
              : {
                  fontSize: "8px",
                  width: "16.8cm",
                  margin: "8em auto 0",
                  transformOrigin: "50% 15%",
                }
          }
        >
          {infoUpdating ? <div style={{display: 'flex', alignItems: 'center'}}><Loader style={{width:16, height: 16}}/>Updating...</div> : <div style={{display: 'flex', alignItems: 'center'}}><Check style={{width:12, height: 16, marginRight: 2}}/> Updated</div>}
          
          {/* <span><CloudUploadAnimated style={{verticalAlign:'middle'}}/> Saving...</span>
          <span><CloudDoneAnimated style={{verticalAlign:'middle'}}/> Saved</span> */}
          <div id="pdf">
            <div
              style={{
                fontSize: activeSection == "preview" ? activeFontSize : "8px",
              }}
            >
              {populateResumeDesign(resumeInfo)}
            </div>
          </div>
        </div>
        {activeSection !== "preview" && (
          <div className={styles.resumeActions}>
            <Button
              type="link"
              content={
                <>
                  <MagicWand /> Change Design
                </>
              }
              onClick={() => setSearchParams({ section: "preview" })}
            />
            <Button
              content="Preview & Download"
              onClick={() => setSearchParams({ section: "preview" })}
            />
          </div>
        )}
      </div>
      
      {/* For Mobile View */}
      <div className={styles.mobileButton}>
        <button onClick={() => togglePreviewBar(true)}>
          <MagicWand />
        </button>
        <button onClick={() => togglePreviewBar(true)} style={{width: 'auto', padding: '0 24px', fontWeight: 500, display: 'flex', alignItems: 'center', fontSize: 14}}>
          <Download style={{marginRight: 8}} /> Download
        </button>
      </div>
      {showPrevieBar && <div className={styles.previewBar}>
          <button onClick={() => togglePreviewBar(false)} className={styles.closeBtn}>
            <CrossSvg />
          </button>
          <PreviewBar togglePreviewBar={togglePreviewBar} toggleUpgradeModal={props.toggleUpgradeModal}/>
      </div>}
    </>
  );
}

export default Resume;
